import { forwardRef } from 'react';
import type { LanguageCode, LanguageName } from '../../../types';
import type { FlagProps } from '../flag';
import { StyleLayout } from '../layout';
import { Arrow } from './arrow';

export type DropdownAnchorItemProps = {
  languageCode: LanguageCode;
  icon?: FlagProps['icon'];
  iconStyle?: FlagProps['style'];
  iconName?: FlagProps['iconName'];
  name?: LanguageName;
  isOpen?: boolean;
  setOpenRequest(): void;
};

export const DropdownAnchorItem = forwardRef<
  HTMLDivElement,
  DropdownAnchorItemProps
>(
  (
    {
      languageCode,
      icon,
      iconStyle,
      iconName,
      name,
      isOpen = false,
      setOpenRequest
    },
    forwardingRef
  ) => {
    const displayIcon = !!icon || !!iconName;

    return (
      <StyleLayout.Container
        ref={forwardingRef}
        languageCode={languageCode}
        isDropdown
        isOpen={isOpen}
        onClick={setOpenRequest}
      >
        {displayIcon && (
          <StyleLayout.Flag
            icon={icon}
            style={iconStyle}
            iconName={iconName}
            languageName={name}
            isDecorative={!!name}
          />
        )}
        {!!name && <StyleLayout.Name name={name} />}
        <Arrow />
      </StyleLayout.Container>
    );
  }
);
